import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useInput, useTranslate } from 'react-admin';

import { filterColors } from '../../utils/constants';
import { FilterToggleButtonGroup, StyledToggleButton } from './FilterToggleInput';

const useStyles = makeStyles({
	filterState: {
		backgroundColor: filterColors.activity_state
	},
});


export const ToggleActivityStateEnum = {
	ACTIVE: "active",
	ARCHIVE: "archive",
	ALL: "all",
};

export const ACTIVITY_STATE_ALL_VALUE = ToggleActivityStateEnum.ALL;


export const ToggleActivityStateFilter = (props) => {
	const translate = useTranslate();
	const classes = useStyles();
	const { input } = useInput(props);
	const value = input.value || ToggleActivityStateEnum.ALL;

	const handleChange = (e, newValue) => {
		input.onChange(newValue);
	};

	return (
		<FilterToggleButtonGroup value={value} onChange={handleChange} label={input.label} exclusive className={classes.filterState}>
			<StyledToggleButton value={ToggleActivityStateEnum.ACTIVE}>
				{translate('osfc.filters.activity_state.active')}
			</StyledToggleButton>
			<StyledToggleButton value={ToggleActivityStateEnum.ARCHIVE}>
				{translate('osfc.filters.activity_state.archive')}
			</StyledToggleButton>
			<StyledToggleButton value={ToggleActivityStateEnum.ALL}>
				{translate('osfc.filters.activity_state.all')}
			</StyledToggleButton>
		</FilterToggleButtonGroup>
	);
};
